{
  "eyebrow": "Bekreft abonnementet",
  "title": "Se gjennom og konfigurer.",
  "sub": "Du kan endre faktureringssyklus eller abonnement når som helst fra administratorpanelet.",
  "yourPlan": "Ditt abonnement",
  "changePlan": "Endre abonnement",
  "billing": "Faktureringssyklus",
  "billingMonthLabel": "Betal månedlig",
  "billingMonthDesc": "Fleksibelt. Avslutt når som helst.",
  "billingYearLabel": "Betal årlig",
  "billingYearDesc": "~17% rabatt. Faktureres én gang i året.",
  "addons": "Tillegg",
  "addon": {
    "ssec": "Trygd (check-in/out@work)",
    "ssecDesc": "Bare Belgia — automatisk Dimona-melding.",
    "vtt": "Vehicle Track & Trace",
    "vttDesc": "Live-GPS for firmakjøretøy. +4 €/kjøretøy/måned.",
    "vehicles": "Kjøretøy",
    "projectAddon": "Tillegg for prosjektstyring",
    "projectAddonDesc": "Låser opp Time Pro sine prosjektstyringsfunksjoner (ekstraarbeid, vaktplanlegging, underleverandører)."
  },
  "employees": {
    "title": "Hvor mange ansatte?",
    "active": "aktive brukere",
    "popular": "De fleste team velger {{n}}"
  },
  "estimate": "Estimerte månedlige kostnader",
  "estimateNote": "Eksklusive mva. Brukerkostnader belastes basert på aktive ansatte.",
  "estimateUnavailable": "Priskatalog ikke tilgjengelig. Prøv igjen for å laste de nyeste prisene."
}
